var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menu.length > 0)?_c('section',{attrs:{"id":"menu"}},_vm._l((_vm.menu),function(menuCategory){return _c('menu-category-card',{key:menuCategory.cloverId,attrs:{"menu-category":menuCategory}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }